/** Spec 05 card 3: the toolbar over selected transcript text. Highlight colors, Add note, Share clip, Follow (a site
 *  without accounts, another city's: Share clip alone). */
import { useLayoutEffect, useRef } from "react";
import { MessageSquarePlus, Plus, Scissors } from "lucide-react";
import type { Note } from "../../types";
import { site } from "../../app/site";

export function SelectionToolbar({ x, y, onColor, onAddNote, onShareClip, onFollow }: {
  x: number;
  y: number;
  onColor: (c: Note["color"]) => void;
  onAddNote: () => void;
  onShareClip: () => void;
  onFollow: () => void;
}) {
  // Keep the selection: pressing a button must not clear it before the click lands.
  const keep = (e: React.MouseEvent) => e.preventDefault();
  const ref = useRef<HTMLDivElement>(null);
  // Centered over the selection, but kept inside the panel (8px margin).
  useLayoutEffect(() => {
    const el = ref.current, panel = el?.offsetParent as HTMLElement | null;
    if (!el || !panel) return;
    const half = el.offsetWidth / 2;
    el.style.left = `${Math.min(Math.max(x, half + 8), panel.clientWidth - half - 8)}px`;
  }, [x]);
  return (
    <div ref={ref} className="sel-toolbar" role="toolbar" aria-label="Selection" style={{ left: x, top: y }} onMouseDown={keep}>
      {site.accounts && <>
        {(["yellow", "green", "blue"] as const).map((c) => (
          <button key={c} className="sel-swatch" data-color={c} aria-label={`Highlight ${c}`} onClick={() => onColor(c)} />
        ))}
        <span className="sel-divider" />
        <button className="sel-action" onClick={onAddNote}><MessageSquarePlus size={13} />Add note</button>
        <span className="sel-divider" />
      </>}
      <button className="sel-action" onClick={onShareClip}><Scissors size={13} />Share clip</button>
      {site.accounts && <>
        <span className="sel-divider" />
        <button className="sel-action" onClick={onFollow}><Plus size={13} />Follow</button>
      </>}
    </div>
  );
}
